import React from 'react'
import {useLocation, useParams} from 'react-router-dom'
import {ProvenanceForm} from './components/ProvenanceForm'
import {ModeleProvenance} from '../../../components/Models'

type LocationState = {
  data: ModeleProvenance | undefined | null
}

const ProvenancePage = () => {
  let {provenanceId} = useParams()
  const location = useLocation()
  const state = location.state as LocationState

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>
              {provenanceId === undefined ? 'Créer' : 'Modifier'} une provenance
            </h3>
          </div>
        </div>

        <div>
          <ProvenanceForm id={provenanceId} data={state ? state.data : null} />
        </div>
      </div>
    </>
  )
}

export {ProvenancePage}
